__turbopack_context__.v({
  "body": "SText-module-scss-module__7GMGhW__body",
  "bodySmall": "SText-module-scss-module__7GMGhW__bodySmall",
  "error": "SText-module-scss-module__7GMGhW__error",
  "green200": "SText-module-scss-module__7GMGhW__green200",
  "green300": "SText-module-scss-module__7GMGhW__green300",
  "green400": "SText-module-scss-module__7GMGhW__green400",
  "green500": "SText-module-scss-module__7GMGhW__green500",
  "headlineLarge": "SText-module-scss-module__7GMGhW__headlineLarge",
  "headlineMedium": "SText-module-scss-module__7GMGhW__headlineMedium",
  "headlineSmall": "SText-module-scss-module__7GMGhW__headlineSmall",
  "label": "SText-module-scss-module__7GMGhW__label",
  "mono1_300": "SText-module-scss-module__7GMGhW__mono1_300",
  "mono1_400": "SText-module-scss-module__7GMGhW__mono1_400",
  "mono2_300": "SText-module-scss-module__7GMGhW__mono2_300",
  "o500": "SText-module-scss-module__7GMGhW__o500",
  "r400": "SText-module-scss-module__7GMGhW__r400",
  "r500": "SText-module-scss-module__7GMGhW__r500",
  "r600": "SText-module-scss-module__7GMGhW__r600",
  "title": "SText-module-scss-module__7GMGhW__title",
  "titleLarge": "SText-module-scss-module__7GMGhW__titleLarge",
  "titleMedium": "SText-module-scss-module__7GMGhW__titleMedium",
  "titleSmall": "SText-module-scss-module__7GMGhW__titleSmall",
  "turq300": "SText-module-scss-module__7GMGhW__turq300",
  "turq400": "SText-module-scss-module__7GMGhW__turq400",
  "turq500": "SText-module-scss-module__7GMGhW__turq500",
  "white": "SText-module-scss-module__7GMGhW__white",
});
